import { Box, LinearProgress, Stack, Typography } from "@mui/material";
import { ReactElement } from "react";

import progressImage from "../../../../../assets/image/board.png";

type TExportProgressProps = {
  uploadingProgress: number;
  uploadingTotal: null | number;
};

const ExportProgress = ({
  uploadingProgress,
  uploadingTotal,
}: TExportProgressProps): ReactElement => {
  const value =
    !uploadingTotal || !uploadingTotal
      ? 0
      : Math.min((uploadingProgress / uploadingTotal) * 100, 100);

  return (
    <Stack alignItems="center" gap="16px">
      <Box
        alt="snail"
        component="img"
        src={progressImage}
        sx={styles.image}
        width={139}
      />
      <LinearProgress
        sx={styles.progressBar}
        value={value}
        variant="determinate"
      />
      {uploadingTotal && (
        <Typography sx={styles.text}>
          Processed
          <span>
            {uploadingProgress} / {uploadingTotal}
          </span>
        </Typography>
      )}
    </Stack>
  );
};

const styles = {
  image: {
    transform: "scaleX(-1)",
  },
  progressBar: {
    background: "#e7e7e7",
    borderRadius: "8px",
    height: "12px",
    width: "100%",
  },
  text: {
    "& > span": {
      color: "var(--black)",
      fontSize: "18px",
      marginTop: "-2px",
    },
    alignItems: "center",
    color: "var(--text-grey)",
    display: "inline-flex",
    fontSize: "12px",
    fontWeight: 600,
    gap: "4px",
    lineHeight: 1,
  },
};

export default ExportProgress;
